import { render, staticRenderFns } from "./List.vue?vue&type=template&id=1bf1a492&scoped=true&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"
import style0 from "../Style/list.scss?vue&type=style&index=0&id=1bf1a492&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf1a492",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bf1a492')) {
      api.createRecord('1bf1a492', component.options)
    } else {
      api.reload('1bf1a492', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=1bf1a492&scoped=true&", function () {
      api.rerender('1bf1a492', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/PushNotifications/Components/List.vue"
export default component.exports